import { css } from 'linaria';

export const metalRoofOtherTypesSwiper = css`
  &&& {
    padding-bottom: 15px;
    margin-bottom: -15px;

    @media (--from-tablet) {
      justify-content: flex-start;
      width: 100%;
      padding: 15px 0;
      margin: -15px 0;
    }

    .swiper-button-prev,
    .swiper-button-next {
      @media (--only-tablet) {
        display: flex;
      }
    }

    .swiper-wrapper {
      justify-content: flex-start;
    }
  }
`;

export const metalRoofOtherTypesLink = css`
  &:hover {
    box-shadow: var(--box-shadow-s);
  }
`;

export const metalRoofOtherTypesSlide = css`
  && {
    display: flex;
    width: 377px;
    height: unset;
    margin-right: 24px;

    @media (--only-desktop) {
      width: 297px;
    }

    @media (--only-tablet) {
      width: 210px;
      margin-right: 16px;
    }

    @media (--only-mobile) {
      width: 204px;
      margin-right: 16px;
    }
  }
`;

export const metalRoofOtherTypesCardMedia = css`
  height: 262px;

  @media (--only-desktop) {
    height: 200px;
  }

  @media (--to-desktop) {
    height: 156px;
  }
`;

export const metalRoofOtherTypesMediaCardContent = css`
  && {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    height: 100%;
    padding: 24px;

    @media (--to-desktop) {
      padding: 24px 16px;
    }
  }
`;

export const metalRoofOtherTypesMediaCardText = css`
  margin-bottom: 0;
`;
